"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
const SymfonyRouter_1 = __importDefault(require("@react/common/SymfonyRouter/SymfonyRouter"));
const InputValidator_1 = __importDefault(require("@web/common/InputValidator"));
const DisplayAnimation_1 = __importDefault(require("@web/common/DisplayAnimation"));
const GtmDataLayer_1 = __importDefault(require("@react/common/GtmDataLayer/GtmDataLayer"));
const Message = {
    error: 'Něco se pokazilo, zkuste to prosím znovu.',
    exist: 'Váš e-mail u odběru novinek už evidujeme.',
    success: 'Váš e-mail byl úspěšně přidán do odběru novinek.',
    sending: 'Odesílám...',
    validation: 'Zadali jste nesprávný tvar e-mailu, zkuste to prosím znovu.',
    dnsValidation: 'Zadali jste neplatnou e-mailovou adresu.',
};
function initNewsletter(requestStartedAt) {
    const newsletterSubscriptionElements = Array.from(document.querySelectorAll('.newsletter-subscription-container'));
    const newsletterSubscriptionDiscountPopup = document.querySelector('.newsletter-subscription-container.discount');
    const ENTER_KEY = 'Enter';
    const successIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 130" class="response-icon">'
        + '<circle class="circle" fill="none" stroke="#2dbd58" stroke-width="6" stroke-miterlimit="10"'
        + 'cx="65" cy="65" r="62"/><polyline class="symbol" fill="none" stroke="#2dbd58" stroke-width="6"'
        + 'stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/></svg>';
    function removeErrorMessage(newsletterSubscription) {
        var _a;
        (_a = newsletterSubscription.querySelector('.content .error-message')) === null || _a === void 0 ? void 0 : _a.remove();
    }
    function displayHeadline(newsletterSubscription, message) {
        const contentElement = newsletterSubscription.querySelector('.content');
        newsletterSubscription.classList.remove('error');
        newsletterSubscription.classList.add('complete');
        removeErrorMessage(newsletterSubscription);
        if (contentElement) {
            contentElement.innerHTML = `<h5 class="headline">${successIcon}${message}</h5>`;
        }
    }
    function showErrorMessage(newsletterSubscription, message) {
        const contentElement = newsletterSubscription.querySelector('.content');
        removeErrorMessage(newsletterSubscription);
        if (contentElement) {
            contentElement.insertAdjacentHTML('beforeend', `<div class="error-message">${message}</div>`);
        }
    }
    function openNewsletterSubscriptionDiscountPopup(popup) {
        DisplayAnimation_1.default.fadeIn(popup);
    }
    function closeNewsletterSubscriptionDiscountPopup(popup) {
        DisplayAnimation_1.default.fadeOut(popup);
        const { cookieName } = popup.dataset;
        if (cookieName) {
            js_cookie_1.default.set(cookieName, '1', {
                expires: 30,
                sameSite: 'lax',
                secure: true,
            });
        }
    }
    function shouldDisplayNewsletterSubscriptionDiscountPopup(popup) {
        const { cookieName } = popup.dataset;
        return cookieName === undefined || js_cookie_1.default.get(cookieName) === undefined;
    }
    if (newsletterSubscriptionDiscountPopup && shouldDisplayNewsletterSubscriptionDiscountPopup(newsletterSubscriptionDiscountPopup)) {
        const newsletterSubscriptionDiscountPopupClose = newsletterSubscriptionDiscountPopup.querySelector('.close-popup');
        const millisecondsFromRequestStart = ((new Date()).getTime() - requestStartedAt.getTime());
        const popupShowDelay = 5000 - millisecondsFromRequestStart;
        setTimeout(() => {
            openNewsletterSubscriptionDiscountPopup(newsletterSubscriptionDiscountPopup);
        }, Math.max(popupShowDelay, 1));
        if (newsletterSubscriptionDiscountPopupClose) {
            newsletterSubscriptionDiscountPopupClose.addEventListener('click', () => {
                closeNewsletterSubscriptionDiscountPopup(newsletterSubscriptionDiscountPopup);
            });
        }
    }
    function pushGtmEvent(gtmEventLabel) {
        (0, GtmDataLayer_1.default)({
            event: 'newsletter_subscription_agreement_success_event',
            eventLabel: gtmEventLabel,
        });
    }
    function sendNewsletterSubscriptionRequest(newsletterSubscription, newsletterEmailInput, newsletterButton) {
        const emailAddress = newsletterEmailInput.value;
        const { agreementSource } = newsletterEmailInput.dataset;
        const url = SymfonyRouter_1.default.getRoute('api.newsletter_subscription.add_email', {
            base64Email: window.btoa(emailAddress),
            source: agreementSource,
        });
        let defaultText = '';
        const xhr = new XMLHttpRequest();
        if (InputValidator_1.default.isEmailValid(emailAddress) === true) {
            xhr.open('PUT', url, true);
            xhr.onloadstart = () => {
                defaultText = newsletterButton.innerText;
                removeErrorMessage(newsletterSubscription);
                newsletterButton.innerText = Message.sending;
            };
            xhr.onload = () => {
                if (xhr.status === 200) {
                    displayHeadline(newsletterSubscription, Message.success);
                    pushGtmEvent(agreementSource);
                    if (newsletterSubscription.classList.contains('discount')) {
                        setTimeout(() => {
                            closeNewsletterSubscriptionDiscountPopup(newsletterSubscription);
                        }, 3000);
                    }
                }
                else if (xhr.status === 409) {
                    displayHeadline(newsletterSubscription, Message.exist);
                }
                else if (xhr.status === 422) {
                    newsletterSubscription.classList.add('error');
                    newsletterButton.innerText = defaultText;
                    showErrorMessage(newsletterSubscription, Message.dnsValidation);
                }
                else {
                    newsletterSubscription.classList.add('error');
                    newsletterButton.innerText = defaultText;
                    showErrorMessage(newsletterSubscription, Message.error);
                }
            };
            xhr.send();
        }
        else {
            showErrorMessage(newsletterSubscription, Message.validation);
        }
    }
    newsletterSubscriptionElements.forEach((newsletterSubscription) => {
        const newsletterEmailInput = newsletterSubscription.querySelector('.newsletter-form-email-input');
        const newsletterButton = newsletterSubscription.querySelector('.add-newsletter-subscription-email');
        newsletterSubscription.classList.add('active');
        newsletterSubscription.style.removeProperty('display');
        if (newsletterEmailInput && newsletterButton) {
            newsletterEmailInput.addEventListener('keypress', (evt) => {
                if (evt.key === ENTER_KEY) {
                    sendNewsletterSubscriptionRequest(newsletterSubscription, newsletterEmailInput, newsletterButton);
                }
            });
            newsletterButton.addEventListener('click', (evt) => {
                evt.preventDefault();
                sendNewsletterSubscriptionRequest(newsletterSubscription, newsletterEmailInput, newsletterButton);
            });
        }
    });
}
function initNewsletterIfUserNotSubscribed() {
    const requestStartedAt = new Date();
    fetch(SymfonyRouter_1.default.getRoute('api.newsletter_subscription.get_user_subscription_status', {}))
        .then((response) => {
        if (response.status === 404) {
            initNewsletter(requestStartedAt);
        }
    })
        .catch((e) => {
        console.warn(`Catch initNewsletterIfUserNotSubscribed error | ${e}`);
    });
}
initNewsletterIfUserNotSubscribed();
